import React from 'react';
import './BaseLayout.scss';
import { Outlet } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import BatchSelect from '../../components/BatchSelect';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import ErrorBoundary from '../ErrorBoundary';

const BaseLayout = () => {
  return (
    <>
      <ErrorBoundary>
        <Header />
        <Outlet />
        <Footer />
        <BatchSelect />
      </ErrorBoundary>
      <ToastContainer
        position='bottom-right'
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme='dark'
      />
    </>
  );
};

export default BaseLayout;
